import type { ObjectId } from "@bbj-types/utils";
import { Authorizer } from "@navigations/Authorizer";
import { AttachmentsWithoutCandidateId } from "./noCandidateId";
import type { IAttachmentsWithCandidateDocumentsBaseProps } from "./types";
import { AttachmentsWithCandidateDocuments } from "./withCandidateId";

interface IAttchmentFilesButtonProps extends IAttachmentsWithCandidateDocumentsBaseProps {
  candidateId?: ObjectId;
}

export const AttachmentFilesButton = ({ candidateId, control, setAttachmentsLoading }: IAttchmentFilesButtonProps) => {
  if (candidateId) {
    return (
      <Authorizer
        requiredPermissions={["communication.email.attachments"]}
        Authorized={AttachmentsWithCandidateDocuments}
        AuthorizedProps={{ control, candidateId, setAttachmentsLoading }}
      />
    );
  }

  return (
    <Authorizer
      requiredPermissions={["communication.email.attachments"]}
      Authorized={AttachmentsWithoutCandidateId}
      AuthorizedProps={{ control, setAttachmentsLoading }}
    />
  );
};
